import React from 'react'
import { LazyTheWestLivePlayerPage } from './TheWestLivePlayerPage.lazy'
import { createRegisterableComponent } from '@news-mono/web-common'
import { AdUnitWrapper } from '../../../advertising/AdUnit/AdUnitWrapper'
import { AdUnitInformation } from '../../../advertising/advertising.routing'

export interface TheWestLivePlayerPageRouteProps {
    adUnit?: AdUnitInformation['data']
}

export const TheWestLivePlayerPageRegistration = createRegisterableComponent(
    'the-west-live-player-page',
    (props: TheWestLivePlayerPageRouteProps, services) => {
        const shareUrl = services.config.publicUrl + services.location.pathname
        const adUnit = props.adUnit && (
            <AdUnitWrapper
                {...props.adUnit}
                adState={services.adState}
                unitId={props.adUnit.slot.id}
                onEvent={services.onEvent}
            />
        )
        return (
            <LazyTheWestLivePlayerPage
                shareUrl={shareUrl}
                onEvent={services.onEvent}
                showSponsorLogo={true} // Sponsor logo for west live player page
                adUnit={adUnit}
            />
        )
    },
)
